import { InteractiveLoginRequiredAuthError } from '@ms/yammer-web-authenticators';

export const isInteractiveLoginRequiredAuthError = (error: unknown): error is InteractiveLoginRequiredAuthError =>
  error instanceof InteractiveLoginRequiredAuthError;
